module.exports = __webpack_public_path__ + "media/images/logo2-e46c7c43b5469a54984f386cb6d09fae.png";